exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editor[data-v-2519f170],.work-preview-wrap[data-v-2519f170]{width:100%;height:100%;border:0}.loading-mask[data-v-2519f170]{position:absolute;top:0;left:0;bottom:0;right:0;z-index:5;background-color:rgba(0,0,0,.3);display:flex;flex-direction:column;align-items:center;justify-content:center}", ""]);

// exports
